import { createContext, useContext } from 'react';
import { Telemetry } from './loggers/Logger';

export const TelemetryContext = createContext<Telemetry | undefined>();

export function useTelemetryContext(): Telemetry {
    const context = useContext(TelemetryContext);
    if (context === undefined) {
        throw new Error('useTelemetry must be used within a TelemetryServiceProvider!');
    }
    return context;
}
